import { generateWidgetContext } from '../widget-wrapper';

export const TrendingWidgetContext = generateWidgetContext();
